// src/App.js
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux';
//
import AppRoutes from './route/AppRoute';
//
import LoadingModal from './components/LoadingModal';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <AppRoutes />
          <LoadingModal />
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
